import { initialState, RootStateType } from './connection';
import { ConnectionStateType } from './connection';

export const getConnectionState = (rootState: RootStateType): ConnectionStateType => {
	return rootState.connection || initialState;
};

export const getIsOnline = (rootState: RootStateType): boolean => {
	return !!getConnectionState(rootState).online;
};

export const getHasRequestErrors = (rootState: RootStateType): boolean => {
	return getConnectionState(rootState).requestErrors.length > 0;
};

export const getHasChunkErrors = (rootState: RootStateType): boolean => {
	return getConnectionState(rootState).chunkLoadingErrors.length > 0;
};

export const getAnyOutgoingSaveRequestFailed = (rootState: RootStateType): boolean => {
	return !!getConnectionState(rootState).outgoingSaveRequestFailed;
};

export const getAnyOutgoingFetchRequestFailed = (rootState: RootStateType): boolean => {
	return !!getConnectionState(rootState).outgoingFetchRequestFailed;
};

export const getAssumeUserIsOffline = (rootState: RootStateType): boolean => {
	const isOnline = getIsOnline(rootState);

	return [
		!isOnline,
		[
			(getHasChunkErrors(rootState), getHasRequestErrors(rootState)),
			getAnyOutgoingFetchRequestFailed(rootState),
			getAnyOutgoingSaveRequestFailed(rootState),
		].some((value: boolean): boolean => value === true),
	].every((flag: boolean) => flag === true);
};
